import React from 'react';
import { useSelector } from 'react-redux';
import AccessDenied from './UnauthorizedPage';
const ProtectedRoute = ({ children, allowedPermissions }) => {
    const { permissions } = useSelector((state) => state.auth);

    // Check if the user has at least one of the allowed permissions
    const hasPermission = allowedPermissions.some((permission) =>
        permissions.includes(permission)
    );

    if (!hasPermission) {
        return <AccessDenied  isFullPage={false} />
    }

    return children;
};

export default ProtectedRoute;